import { captureException } from '@sentry/react'
import { useEffect, useRef } from 'react'
import { useRouteError } from 'react-router'
import { Error } from './Error'
import { Layout } from './Layout'

export const ErrorBoundary = () => {
  const error = useRouteError()
  // A ref, not state: this only dedupes repeat reports for the same error, and
  // storing it in state made the effect depend on a value it also sets.
  const loggedError = useRef<unknown>(undefined)

  useEffect(() => {
    if (error !== loggedError.current) {
      loggedError.current = error
      // log the error in sentry
      captureException(error)
    }
  }, [error])

  return (
    <Layout>
      <Error
        patientHint={!window.location.pathname.startsWith('/admin')}
      >
        Something went wrong, we have been notified and will look into it
      </Error>
    </Layout>
  )
}
